import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import styles from "./BackorderedItemBanner.module.scss";

interface BackorderedItemBannerProps {
  children: React.ReactNode;
  className?: string;
  count?: number;
}

export default function BackorderedItemBanner({
  children,
  className,
  count = 1,
}: BackorderedItemBannerProps): React.JSX.Element {
  const isPlural = count > 1;
  return (
    <div
      className={classnames(styles.wrapper, className)}
      data-testid="backordered-item-banner"
    >
      <div className={styles.banner}>
        <span className={styles.bannerLeft}>
          {isPlural ? "These items are on backorder." : "This item is on backorder."}
        </span>
        <span className={styles.bannerRight}>
          We&apos;ll notify you when {isPlural ? "they are" : "it&apos;s"} back in stock.{" "}
          <Link to="/support" className={styles.repLink}>
            Contact your rep
          </Link>{" "}
          for more info.
        </span>
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}
